// extracted by mini-css-extract-plugin
export default {"plateDescription":"aZGD0G"};